import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { Tile } from "../Tile";

import styles from "./ProductTile.scss";

import ProductTileVisuals from "./ProductTileVisuals";
import ProductTileTextContent from "./ProductTileTextContent";
import ProductTileTopline from "./ProductTileTopline";
import ProductTileTitle from "./ProductTileTitle";
import ProductTilePicture from "./ProductTilePicture";
import ProductTileIcon from "./ProductTileIcon";
import ProductTileColors from "./ProductTileColors";
import ProductTileDescription from "./ProductTileDescription";
import ProductTilePrice from "./ProductTilePrice";
import ProductTilePriceText from "./ProductTilePriceText";
import ProductTileTextLink from "./ProductTileTextLink";
import ProductTileButton from "./ProductTileButton";

export const ProductTile = forwardRef(
  (
    {
      children,
      href,
      isHover,
      variant,
      customClass,
      wrapperProps,
      ...restProps
    },
    ref
  ) => {
    const Tag = href && variant !== ProductTile.Variant.option ? "a" : "div";
    return (
      <Tag
        href={(variant !== ProductTile.Variant.option && href) || undefined}
        className={cx(styles.link, styles.productTile, customClass, variant)}
        ref={ref}
        {...wrapperProps}
      >
        <Tile hover={isHover} variant="shadow" {...restProps}>
          <div className={styles.tileInner}>{children}</div>
        </Tile>
      </Tag>
    );
  }
);

ProductTile.displayName = "ProductTile";

ProductTile.Variant = {
  hardware: styles.hardwareTile,
  accessory: styles.accessoryTile,
  option: styles.optionTile,
};

ProductTile.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  href: PropTypes.string,
  isHover: PropTypes.bool,
  variant: PropTypes.oneOf([
    ProductTile.Variant.hardware,
    ProductTile.Variant.accessory,
    ProductTile.Variant.option,
  ]).isRequired,
  customClass: PropTypes.string,
  wrapperProps: PropTypes.objectOf(PropTypes.any),
};

ProductTile.defaultProps = {
  isHover: false,
  customClass: undefined,
  wrapperProps: null,
  href: undefined,
};

ProductTile.Visuals = ProductTileVisuals;
ProductTile.TextContent = ProductTileTextContent;
ProductTile.Topline = ProductTileTopline;
ProductTile.Title = ProductTileTitle;
ProductTile.Picture = ProductTilePicture;
ProductTile.Icon = ProductTileIcon;
ProductTile.Colors = ProductTileColors;
ProductTile.Description = ProductTileDescription;
ProductTile.Price = ProductTilePrice;
ProductTile.PriceText = ProductTilePriceText;
ProductTile.TextLink = ProductTileTextLink;
ProductTile.Button = ProductTileButton;

export default ProductTile;
